import React from "react";

const EnableMFA = () => {
  return <div>EnableMFA</div>;
};

export default EnableMFA;

// // export default EnableMFA;
// import React, { useState } from "react";
// import { useDispatch } from "react-redux";
// import {
//   useGenerateMFASecretQuery,
//   useVerifyMFATokenMutation,
// } from "../slices/authSlice";
// import Button from "../components/utilComponents/Button";

// const EnableMFA = () => {
//   const [token, setToken] = useState("");
//   const [message, setMessage] = useState("");
//   const dispatch = useDispatch();

//   const { data, error, isLoading, refetch } = useGenerateMFASecretQuery();
//   const [verifyMFAToken] = useVerifyMFATokenMutation();

//   const handleVerifyMFAToken = async () => {
//     try {
//       const response = await verifyMFAToken({
//         token,
//         superAdminId: data.superAdminId, // Include superAdminId if needed
//       }).unwrap();
//       setMessage(response.message);
//       dispatch({ type: "frontendAuth/enableMFA", payload: true });
//     } catch (error) {
//       console.error("Error verifying MFA token:", error);
//       setMessage("Invalid MFA token");
//     }
//   };

//   if (isLoading) return <div>Loading...</div>;
//   if (error) return <div>Error loading QR code</div>;

//   return (
//     <div>
//       <Button onClick={refetch}>Generate MFA Secret</Button>
//       {data && (
//         <div>
//           <img src={data.qrCodeUrl} alt="MFA QR Code" />
//           <input
//             type="text"
//             value={token}
//             onChange={(e) => setToken(e.target.value)}
//             placeholder="Enter MFA token"
//           />
//           <Button onClick={handleVerifyMFAToken}>Verify MFA Token</Button>
//         </div>
//       )}
//       {message && <p>{message}</p>}
//     </div>
//   );
// };

// export default EnableMFA;
